import React from 'react';
import FormModal, { ModalProps } from './FormModal';

const DeleteModal: React.FC<ModalProps> = ({ children, ...rest }) => (
  <FormModal variant="blank" {...rest} buttonText="Slet">
    {children}
  </FormModal>
);

export default DeleteModal;
